import { queryKeys } from '@/lib/query-keys';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

export function CallbackPage() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const error = searchParams.get('error');
	// Truncate error for display — React escapes HTML, but limit length for safety
	const displayError = error && error.length > 200 ? 'Authentication error' : error;

	useEffect(() => {
		if (error) return;
		// The server-side callback has already set the session cookie.
		// Invalidate the auth query so it refetches with the new cookie.
		queryClient.invalidateQueries({ queryKey: queryKeys.auth.me }).then(() => {
			navigate('/', { replace: true });
		});
	}, [error, navigate, queryClient]);

	if (error) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-background">
				<div className="space-y-4 text-center">
					<h1 className="text-xl font-semibold text-foreground">Authentication Failed</h1>
					<p className="text-muted-foreground">{displayError}</p>
					<a href="/login" className="text-sm text-primary hover:underline">
						Try again
					</a>
				</div>
			</div>
		);
	}

	return (
		<div className="flex min-h-screen items-center justify-center bg-background">
			<div className="text-muted-foreground">Completing sign in...</div>
		</div>
	);
}
